import { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Form, Input, Button, message, Card } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import qs from 'qs';
import logo from 'assets/images/logo.png';
// actions
import { resetPassword } from 'requests/auth';
import { setCookie } from 'utils/cookie';

const ResetPassword = () => {
    const [loading, setLoading] = useState(false);
    const [token, setToken] = useState('');

    const navigate = useNavigate();
    const location = useLocation();
    const { t } = useTranslation();

    useEffect(() => {
        const query = qs.parse(location.search.substring(1));
        setToken(query.token);
    }, []);

    const onSubmit = async (data) => {
        if (data.password === data.confirm_password) {
            try {
                setCookie(process.env.REACT_APP_TOKEN_NAME, token, 1 / 48);
                setLoading(true);
                const payload = {
                    password: data.password,
                };
                await resetPassword(payload);
                navigate('/reset-password/result', { replace: true });
            } catch (err) {
                console.log(err);
                message.error(t(err.response?.data.message || 'error'));
            } finally {
                setLoading(false);
            }
        }
    };

    return (
        <div className="form-signin mt-121">
            <img className="logo" src={logo} alt="" />
            <h3>{t('create')}</h3>
            <p className="mb-24">{t('text_new_password')}</p>
            <Card className="card-password card-border">
                <Form layout="vertical" onFinish={onSubmit}>
                    <Form.Item
                        name="password"
                        label={t('password')}
                        extra={t('extra_password')}
                        rules={[
                            {
                                pattern: /^(?=.*[A-Za-z])(?=.*\d)(?=.*[\W_])[A-Za-z\d\W_]{8,}$/,
                                message: t('invalid_format'),
                            },
                        ]}
                    >
                        <Input.Password placeholder={t('new_password')} />
                    </Form.Item>
                    <Form.Item
                        name="confirm_password"
                        label={t('confirm_password')}
                        className="password-confirm mb-64"
                        extra={t('extra_confirm_password')}
                    >
                        <Input.Password placeholder={t('re_enter_password')} />
                    </Form.Item>
                    <Button className="authentication-btn" type="primary" htmlType="submit" loading={loading}>
                        {t('reset_password')}
                    </Button>
                </Form>
            </Card>
            <Link to={'/signin'} className="btn-back mt-40">
                <ArrowLeftOutlined />
                {t('back')}
            </Link>
        </div>
    );
};

export default ResetPassword;
